<pw-view-title>PTT Begleitschein {{(position$ | async)?.NAME}}</pw-view-title>

<pw-view-actions>
  <button *ngIf="pos && pos.INDEX_AI" mat-icon-button color="accent" matTooltip="Lieferschein erstellen"
          (click)="createDeliveryNote()">
    <mat-icon>add</mat-icon>
  </button>
</pw-view-actions>

<mat-accordion *ngIf="pbo$ | async; let pbo">
  <mat-expansion-panel>
    <mat-expansion-panel-header>
      <mat-panel-title>Bestellinformationen {{pbo.NAME}}</mat-panel-title>
    </mat-expansion-panel-header>
    <div class="ps-grid-4-col">
      <div>Beschreibung: {{pbo.DESCRIPTION}}</div>
      <div>Lieferant: {{pbo.LIEFERANT}}</div>
      <div>Projekt: {{pbo.PROJEKTNAME}}</div>
      <div>Termin: {{pbo.TERMIN | date}}</div>
      <div>Status:
        <img *ngIf="pboStatusIcons" src="{{pboStatusIcons[pbo.LIEFERSTATUS_ICON]}}"/>{{pbo.LIEFERSTATUS}}
      </div>
    </div>
  </mat-expansion-panel>
</mat-accordion>

<mat-form-field>
  <mat-label>Filter</mat-label>
  <input type="text" matInput placeholder="Filter" [formControl]="searchFormControl">
</mat-form-field>


<div *ngIf="(deliveryNotes$ | async) as notes" class="margin-top-16 ps-grid-4-col" [ngSwitch]="notes.length">
  <ng-container *ngSwitchCase="0">
    <mat-card>
      <mat-card-content>
        Keine Lieferscheine vorhanden
      </mat-card-content>
    </mat-card>
  </ng-container>
  <ng-container *ngSwitchDefault>
    <mat-card *ngFor="let note of notes">
      <mat-card-title>
        <img class="mat-image" src="{{note.ICON_URL}}">
        {{note.NAME}}
      </mat-card-title>
      <mat-card-content>
        <div gdColumns="auto auto">
          <div>Teilebegleitschein: {{note.DELIVERYNOTE}}</div>
          <div>Status: <img *ngIf="icons" class="mat-icon" [src]="icons.get(note.FREIGABE_ICON)"> {{note.FREIGABE}}
          </div>
          <div>Anzahl: {{note.COUNT_DELIVERED}}</div>
        </div>
      </mat-card-content>
      <mat-card-actions align="end">
        <button *ngIf="note.FREIGABE_GUID != guidDelivered" class="card-button" mat-button color="primary"
                matTooltip="Stornieren" (click)="cancelDelivery(note.OBJECT_ID)">
          <mat-icon>
            delete forever
          </mat-icon>
        </button>
        <button class="card-button" mat-button matTooltip="Download"
                color="primary" (click)="downloadDeliveryNote(note)">
          <mat-icon>download</mat-icon>
        </button>
      </mat-card-actions>
    </mat-card>
  </ng-container>
</div>




